import { useQuery } from "@tanstack/react-query";
import { coreService } from "../api/services/coreService";

export const fundKeys = {
  all: ["funds"] as const,
  list: () => [...fundKeys.all, "list"] as const,
};

export interface Fund {
  key: string;
  value: string;
}

export function useAvailableFunds() {
  return useQuery({
    queryKey: fundKeys.list(),
    queryFn: async () => {
      try {
        const response = await coreService.getAvailableFunds();
        if (response.data) {
          return response.data.map((fund: any) => ({
            key: fund.dbname || fund.key,
            value: fund.fundname || fund.value,
          }));
        }
        return [];
      } catch (error) {
        console.error("Error fetching available funds:", error);
        return [];
      }
    },
    staleTime: 1000 * 60 * 10,
    retry: false,
  });
}
